// src/components/ui/table/table-cell-text.js
import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, Typography } from '@mui/material';

const TableCellText = ({
  children,
  align = 'left',
  fontSize = '0.875rem',
  fontWeight = 400,
  color = 'text.primary',
  flex = '0 0 auto', // consistent default
  sx = {},
  cellProps = {},
  ...rest
}) => {
  return (
    <TableCell align={align} sx={{ flex, ...sx }} {...cellProps} {...rest}>
      {typeof children === 'string' || typeof children === 'number' ? (
        <Typography
          variant="body2"
          fontSize={fontSize}
          fontWeight={fontWeight}
          color={color}
          textAlign={align}
          sx={{ m: 0 }}
        >
          {children}
        </Typography>
      ) : (
        children
      )}
    </TableCell>
  );
};

TableCellText.propTypes = {
  children: PropTypes.node,
  align: PropTypes.oneOf(['left', 'right', 'center']),
  fontSize: PropTypes.string,
  fontWeight: PropTypes.number,
  color: PropTypes.string,
  flex: PropTypes.string,
  sx: PropTypes.object,
  cellProps: PropTypes.object,
};

export default TableCellText;
